import React from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import QueryClientProvider from '@/providers/QueryClientProvider';

import I18nProvider from './providers/I18nProvider';
import { DefaultRouter } from './router/DefaultRouter';
import './styles/index.css';

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider>
        <I18nProvider>
          <DefaultRouter />
        </I18nProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
